import * as React from 'react';
import { cn } from '../lib/utils';
import { Label } from './ui/label';

export interface FieldProps {
  label?: React.ReactNode;
  /** Links the label to the control. Pass the control's `id`. */
  htmlFor?: string;
  description?: React.ReactNode;
  error?: React.ReactNode;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

/**
 * A label stacked over a control, for controls that are not part of a
 * react-hook-form form — filter bars, inline editors, settings toggles. Inside a
 * form, use `FormItem`/`FormLabel`/`FormMessage` instead, which also wire the
 * error semantics onto the control.
 */
export function Field({
  label,
  htmlFor,
  description,
  error,
  required,
  className,
  children,
}: FieldProps) {
  return (
    <div className={cn('grid min-w-0 content-start gap-2', className)}>
      {label ? (
        <Label htmlFor={htmlFor}>
          {label}
          {required ? (
            <span aria-hidden className="-ms-1 text-destructive">
              *
            </span>
          ) : null}
        </Label>
      ) : null}
      {children}
      {error ? (
        <p className="text-xs text-destructive">{error}</p>
      ) : description ? (
        <p className="text-xs text-muted-foreground">{description}</p>
      ) : null}
    </div>
  );
}
